module.exports = __webpack_public_path__ + "img/flicker_orange.6e17edc4.gif";